import React from 'react';
import EsDeskMonitor from './EsDeskMonitor';
// RIGEL — RTH ES trend LONG (Grade A/B). Wave 2.
export default function RigelMonitor() { return <EsDeskMonitor system="rigel" accent="#2962ff" />; }
